<template>
  <div class="grid mt-8 gap-4 grid-cols-5 ">
      <div v-for="(title, color) in colors" :key="color" class="text-sm  flex flex-col">
        <span :class="color" class="h-16 w-16 block rounded shadow border"></span>
        <div class="mt-2 block text-left">{{ title }}</div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colors: {
          'bg-success': 'Sucesso',
          'bg-error': 'Erro',
          'bg-selected': 'Selecionado',
          'bg-disabled': 'Desabilitado',
          'bg-black': 'Preto',
          'bg-gray-800' : 'Cinza 80%',
          'bg-gray-500' : 'Cinza 50%',
          'bg-gray-300' : 'Cinza 30%',
          'bg-gray-200' : 'Cinza 20%',
          'bg-gray-100' : 'Cinza 10%',
          'bg-white': 'Branco',
          'bg-primary': 'Primary',
          'bg-shade': 'Shade',
          'bg-highlight': 'Highlight',
      }
    }
  }
}
</script>